<div class="pagination-container">
    <nav aria-label="pagination-header">
        <ul>
            <li class="pagination-prev">
                <button aria-label="Go To Previous Page" [attr.aria-disabled]="current === 1" [disabled]="current === 1"
                    [attr.aria-hidden]="total === 0" [hidden]="total === 0" (click)="onPrevious()">
                    ❮ Previous
                </button>
            </li>
            <li *ngFor="let page of pages;" class="pagination-item">
                <a 
                    [ngClass]="{'inactiveLink' : page == '..'}" 
                    [attr.aria-current]="page === current ? 'page' : null" 
                    [attr.aria-label]="page === current ? 'Current Page, Page ' + page : 'Go to Page ' + page" 
                    [class.current]="page === current" 
                    [attr.aria-hidden]="total === 0" 
                    [hidden]="total === 0" tabindex="0"
                    (click)="onGoTo(page)" (keyup.enter)="onGoTo(page)">
                    {{ page }}
                </a>
            </li>
            <li class="pagination-next">
                <button aria-label="Go To Next Page" [attr.aria-disabled]="current === total" [disabled]="current === total"
                    [attr.aria-hidden]="total === 0" [hidden]="total === 0" (click)="onNext()">
                    Next ❯
                </button>
            </li>
        </ul>
    </nav>
</div>